import React from 'react';
import { CivilDate } from 'tc39-proposal-temporal';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { compareCivilDate } from '@bingads-webui-universal/temporal-utitlities';
import { Toggle } from '@bingads-webui-react/toggle';

const i18nMap = {
  selected: _TL_('Selected'),
  compared: _TL_('Compare'),
  compareLabel: _TL_('Compared date ranges'),
  on: _TL_('On'),
  off: _TL_('Off'),
};

export class RangeDisplayAndToggle extends React.Component {
  /*  eslint-disable jsx-a11y/label-has-for */
  /*  label is for toggle not input */

  static defaultProps = {
    specificRangeId: -1,
    selectedDateRange: { start: undefined, end: undefined },
    selectedComparedDateRange: { start: undefined, end: undefined },
    onSwitchCompare: undefined,
    selectedOption: undefined,
    highlightInputIndex: -1,
  }

  shouldComponentUpdate(nextProps) {
    if (
      !nextProps.selectedDateRange.start ||
      !this.props.selectedDateRange.start ||
      !nextProps.selectedDateRange.end ||
      !this.props.selectedDateRange.end ||
      compareCivilDate(
        nextProps.selectedDateRange.start,
        this.props.selectedDateRange.start
      ) !== 0 ||
      compareCivilDate(nextProps.selectedDateRange.end, this.props.selectedDateRange.end) !== 0 ||
      nextProps.specificRangeId !== this.props.specificRangeId ||
      nextProps.highlightInputIndex !== this.props.specificRangeId ||
      nextProps.selectedOption !== this.props.selectedOption ||
      nextProps.isCompareOn !== this.props.isCompareOn ||
      (nextProps.isCompareOn &&
        (!this.props.selectedComparedDateRange.start ||
        !this.props.selectedComparedDateRange.end ||
        !nextProps.selectedComparedDateRange.start ||
        !nextProps.selectedComparedDateRange.end)) ||
      (nextProps.isCompareOn &&
        compareCivilDate(
          nextProps.selectedComparedDateRange.start,
          this.props.selectedComparedDateRange.start
        ) !== 0) ||
      (nextProps.isCompareOn
      && compareCivilDate(
        nextProps.selectedComparedDateRange.end,
        this.props.selectedComparedDateRange.end
      ) !== 0)) {
      return true;
    }

    return false;
  }

  render() {
    const {
      specificRanges,
      specificRangeId,
      i18n,
      isCompareEnabled,
      isCompareOn,
    } = this.props;
    const selectedRange = specificRangeId !== -1 ?
      _.filter(specificRanges, range => range.rangeId === specificRangeId)[0] : null;
    const label = `${i18n.getString(i18nMap.selected)}${selectedRange ?
      `: ${selectedRange.text}` : ''}`;
    const marker = isCompareOn ? i18n.getString(i18nMap.on) : i18n.getString(i18nMap.off);
    return (
      <div className="toggle-part" style={isCompareEnabled ? {} : { visibility: 'hidden' }}>
        <label htmlFor="compared-toggle" className="compared-toggle-label">{this.props.i18n.getString(i18nMap.compared)}</label>
        <Toggle
          id="compared-toggle"
          name="compared-toggle"
          label={i18n.getString(i18nMap.compareLabel)}
          className="compared-toggle toggle"
          onChange={this.props.onSwitchCompare}
          checked={this.props.isCompareOn}
          tabIndex="0"
          i18n={i18n}
        />
        <label htmlFor="compared-toggle" className="on-off-marker">{marker}</label>
      </div>
    );
  }
}

RangeDisplayAndToggle.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  selectedDateRange: PropTypes.shape({
    start: PropTypes.instanceOf(CivilDate),
    end: PropTypes.instanceOf(CivilDate),
  }),
  selectedComparedDateRange: PropTypes.shape({
    start: PropTypes.instanceOf(CivilDate),
    end: PropTypes.instanceOf(CivilDate),
  }),
  specificRangeId: PropTypes.number,
  specificRanges: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    range: PropTypes.shape({
      start: PropTypes.instanceOf(CivilDate),
      end: PropTypes.instanceOf(CivilDate),
    }),
  })).isRequired,
  onSwitchCompare: PropTypes.func,
  isCompareEnabled: PropTypes.bool.isRequired,
  isCompareOn: PropTypes.bool.isRequired,
  selectedOption: PropTypes.shape({
    type: PropTypes.number,
    keyToExport: PropTypes.string,
    textToShow: PropTypes.string,
    textToExport: PropTypes.string,
    get: PropTypes.func,
  }),
  highlightInputIndex: PropTypes.number,
};
